<app-dialog [config]="getConfig(dialogConfigs[0])">
  <div class="body">
    <div class="import">
      <div class="file-upload-dropzone" appDragAndDrop (fileDropped)="onFileSelected($event)">
        <input class="file-upload-input" type='file' accept="{{format}}" (change)="onFileSelected($event)" #file/>
        <div class="drag-text">
          <span>{{ 'import.drag-and-drop'|translate }}</span>
          <span>{{ 'common.or'|translate }}</span>
          <button class="file-upload-btn" type="button" (click)="file.click()">{{ 'import.button'|translate }}</button>
        </div>
      </div>
    </div>
    <div class="imported-file">
      @if (importedFiles) {
        <div class="file">
          <i class="fa-light fa-file-import"></i>
          <div>
            <span>{{ importedFiles[0]?.name }}</span>
            <span>{{ importedFiles[0]?.size / 1000|number: '1.0-0' }} ko</span>
          </div>
        </div>
        <button class="button" (click)="onClickImport()">
          @if (loading) {
            <mat-spinner diameter=30></mat-spinner>
          } @else {
            {{ 'import.validate'|translate }}
          }
        </button>
      } @else {
        <span>{{ 'import.no-file'|translate }}</span>
      }
    </div>
  </div>
</app-dialog>
